import React, { useEffect, useState } from 'react';

const avatarOptions = [
  "/images/avatar1.png",
  "/images/avatar2.png",
  "/images/avatar3.png",
  "/images/avatar4.png",
];

function About() {
  const [comments, setComments] = useState([]);
  const [form, setForm] = useState({ message: '', avatar: avatarOptions[0] });
  const [showAll, setShowAll] = useState(false);

  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const currentUser = localStorage.getItem("currentUser") || "";
  const displayName = currentUser.split('@')[0];
  const isAdmin = displayName === "admin";

  const staticComments = [
    {
      name: "Michael",
      message: "One of the best places to stay with various amenities and clean rooms for guests and great and respectful service by the staff.",
      image: "/images/pexels-e.jpg",
      timestamp: "1 May 2024, 9:30 AM",
    },
    {
      name: "Ajitesh",
      message: "Highly reccomend For people looking for a good reputable place to stay for business as the hotel provides a in house conference room for hosting clients and presentations.",
      image: "/images/pexels-b.jpg",
      timestamp: "9 May 2024, 2:15 PM",
    },
  ];

  useEffect(() => {
    document.title = "Hotel Atlanta | About";
    const saved = JSON.parse(localStorage.getItem('guestComments')) || [];
    setComments(saved);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.message) return alert("Message is required");

    const now = new Date();
    const timestamp = now.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    const newComment = { name: displayName, message: form.message, avatar: form.avatar, timestamp };
    const updated = [...comments, newComment];
    setComments(updated);
    localStorage.setItem('guestComments', JSON.stringify(updated));
    setForm({ message: '', avatar: avatarOptions[0] });
  };

  const deleteComment = (index) => {
    const actualIndex = comments.length - visibleDynamicComments.length + index;
    const comment = comments[actualIndex];

    if (isAdmin || comment.name === displayName) {
      const updated = [...comments];
      updated.splice(actualIndex, 1);
      setComments(updated);
      localStorage.setItem('guestComments', JSON.stringify(updated));
    } else {
      alert("You can only delete your own comment.");
    }
  };

  const visibleDynamicComments = showAll
    ? comments
    : comments.slice(-Math.max(0, 4 - staticComments.length));

  return (
    <>
      <section id="about-info" className="bg-light py-3">
        <div className="container">
          <div className="info-left">
            <h1 className="l-heading">
              <span className="text-primary">About</span> Hotel Atlanta
            </h1>
            <p>Hotel Atlanta was founded in 1953 in Gurugram by Mr. AP Singh, a pioneer in Indian hospitality.</p>
            <p>We at Hotel Atlanta pride ourselves in offering the finest services for our customers from around the world with an equisite and refreshing stay at our Hotel whether for vactions or for work related issues. We’ve grown into a trusted destination for families, tourists, and business travelers alike.</p>
          </div>
          <div className="info-right">
            <img
              src={process.env.PUBLIC_URL + "/images/photo-2.jpg"}
              alt="Hotel"
              style={{ width: '100%', borderRadius: '50%' }}
            />
          </div>
        </div>
      </section>

      <section
        id="testimonials"
        className="py-3"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/test-bg.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <h2 className="l-heading">What Our Guests Say</h2>

          {/* Static Comments */}
          {staticComments.map((comment, idx) => (
            <div key={idx} className="testimonials bg-primary">
              <img src={process.env.PUBLIC_URL + comment.image} alt={comment.name} />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
  <span style={{ fontStyle: 'italic', color: '#000', marginBottom: '4px' }}>
    {comment.timestamp}
  </span>
  <p style={{ margin: 0 }}><strong>{comment.name}:</strong> {comment.message}</p>
</div>
            </div>
          ))}

          {/* Dynamic Comments */}
          {visibleDynamicComments.map((entry, idx) => (
            <div key={idx} className="testimonials bg-primary" style={{ position: 'relative' }}>
              <img src={process.env.PUBLIC_URL + (entry.avatar || "/images/guest.png")} alt="Guest" />
             <div style={{ display: 'flex', flexDirection: 'column' }}>
  <span style={{ fontStyle: 'italic', color: '#000', marginBottom: '4px' }}>
    {entry.timestamp}
  </span>
  <p style={{ margin: 0 }}><strong>{entry.name}:</strong> {entry.message}</p>
</div>
              {(isAdmin || entry.name === displayName) && (
                <button
                  onClick={() => deleteComment(idx)}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    fontSize: '18px',
                    cursor: 'pointer',
                  }}
                  title="Delete"
                >
                  ✕
                </button>
              )}
            </div>
          ))}

          {comments.length > (4 - staticComments.length) && (
            <div style={{ marginTop: '15px' }}>
              <button onClick={() => setShowAll(!showAll)} className="btn">
                {showAll ? 'Show Less' : 'Show More'}
              </button>
            </div>
          )}

          {/* Comment Form */}
          <div style={{ marginTop: '40px' }}>
            <h3 style={{ color: '#fff', marginBottom: '15px' }}>Leave a Comment</h3>
            {isLoggedIn ? (
              <form onSubmit={handleSubmit}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '10px' }}>
                  {avatarOptions.map((img, index) => (
                    <img
                      key={index}
                      src={process.env.PUBLIC_URL + img}
                      alt={`Avatar ${index}`}
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        border: form.avatar === img ? '3px solid #f7c08a' : '2px solid #ccc',
                        cursor: 'pointer',
                      }}
                      onClick={() => setForm({ ...form, avatar: img })}
                    />
                  ))}
                </div>
                <input
                  type="text"
                  value={displayName}
                  readOnly
                  style={{ width: '100%', padding: '10px', marginBottom: '10px', backgroundColor: '#ddd' }}
                />
                <textarea
                  placeholder="Your Comment"
                  value={form.message}
                  onChange={e => setForm({ ...form, message: e.target.value })}
                  required
                  style={{ width: '100%', padding: '10px', height: '100px' }}
                />
                <button type="submit" className="btn" style={{ marginTop: '10px' }}>Submit</button>
              </form>
            ) : (
              <p style={{ color: '#fff' }}><em>You must be logged in to leave a comment.</em></p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default About;